import React, { useEffect } from 'react';
import { ModuleBridge, TopActionBar, Flex, Button } from '../components';

export const MigrationPlanner = () => {
    useEffect(() => {
        return () => {
            if (window?.clearPreflightCheckPolling) {
                window?.clearPreflightCheckPolling();
            }
        };
    }, []);

    return (
        <>
            <TopActionBar>
                <Flex gap="small">
                    <Button type="primary" onClick={() => window.exportCSV()}>
                        Export CSV
                    </Button>
                    <Button type="primary" onClick={() => window.modifyColumns()}>
                        Modify Columns
                    </Button>
                </Flex>
            </TopActionBar>
            <div id="migration_planner_container"></div>
            <ModuleBridge moduleId="migration_planner_module" />
        </>
    );
};
